import { Filters } from '../../config/types/config';
import FiltersAction from '../state/filters-action';

const filterBy = <T>(key: keyof Filters<any>, selected: T): FiltersAction => {
  if (key === 'maps') {
    return {
      type: 'filter-by',
      filters: {
        maps: { selected },
      },
    };
  }
  return {
    type: 'filter-by',
    filters: {
      [key]: { selected },
      maps: { selected: [] },
    },
  };
};

export default filterBy;
